class GetReproductionController {
    constructor(OrderAPI,
                localStorageService,
                modal,
                getReproductionService,
                userInfo,
                $state,
                $scope,
                $filter,
                $stateParams,
                $timeout,
                message,
                ArticleAPI,
                WXpayAPI,
                NoLoginPayAPI
                ) {

        "ngInject";

        this.OrderAPI = OrderAPI;
        this.localStorageService = localStorageService;
        this.modal = modal;
        this.reproduction = localStorageService.get('reproduction');
        this.getReproductionService = getReproductionService;
        this.userInfo = userInfo;
        this.$state = $state;
        this.$timeout = $timeout;
        this.message = message;
        this.ArticleAPI = ArticleAPI;
        this.WXpayAPI=WXpayAPI;
        this.NoLoginPayAPI=NoLoginPayAPI;
        this.$scope=$scope

        this.qrCodeSrc = null;
        this.buyStep = 'license';
        this.loading = false;
        this.willingPriceError = false;
        this.tranlsteFilter=$filter('translate');

        this.license = this.original.license;

        let self = this;

        this.getReproductionService.get = () => {
            this.get(self);
        };

        if ($stateParams.action) {
            if ($stateParams.action == 'buy') {
                if (!userInfo.isAuthor(this.original)) {
                    this.get();
                }
            }
        }
    }

    get(self) {

        if (!self) {
            self = this;
        }
        console.log(self.license);

        if (self.license.type === 'cm' || (self.license.type === "cmc" && self.license.content.expire > new Date().getTime()) ) {
            self.buyStep = 'license';
            self.modal.open('cm-license');
        }else{
            if (self.userInfo.isGuest()) {
                let returnUrl = self.$state.href('app.page.original.' + self.type, {
                    'id': self.original.yuanben_id,
                    'action': 'buy'
                });
                self.$state.go('app.face.index.user.form.login', {'return': returnUrl});
                return;
            }
            if (self.license.type === 'cc' || (self.license.type === "cmc" && self.license.content.expire < new Date().getTime())) {
                self.modal.open('cc-license');
            } else if(self.license.type == 'none') {
                self.modal.open('none-license');
                self.articleDemand();
            }
        }

    }

    ccLicenseAgreed() {
        // this.action();
        let post = {
            'original_id': this.original.id,
            'type': this.type
        };
        let self = this;
        self.loading = true;
        this.OrderAPI.one('cc').customPOST(post).then(
            (res) => {

                self.loading = false;
                this.modal.close('cc-license');
                if(res.status.code==200){
                    self.message.success(self.tranlsteFilter('page-original-text123'));
                    self.order = res.data;
                    self.$timeout(() => {

                        if (self.order.order_article) {
                            self.$state.go('app.page.original.articleReproduction', {reproduction: self.order.order_article.yuanben_id});
                        } else {
                            self.$state.go('app.page.original.imageReproduction', {reproduction: self.order.order_image.yuanben_id});
                        }

                    }, 1000);
                }else{
                    self.message.error(res.status.message);
                }

            },
            (response) => {
                self.message.error(response.data);
            }
        );
    }

    cmLicenseAgreed() {
        if (this.type == 'article') {
            this.buyStep = 'reproduction';
        } else {
            this.placeOrder();
        }
    }


    accountNameNeeded(accountType) {
        return ["微信公众号", "微博", "今日头条", "UC头条", "其他"].indexOf(accountType) != -1;
    }

    mediaNameNeeded(accountType) {
        return ["网络媒体", "纸质媒体"].indexOf(accountType) != -1;
    }

    accountIdNeeded(accountType) {
        return ["微信公众号", "其他"].indexOf(accountType) != -1;
    }

    accountLinkNeeded(accountType) {
        return ["微博", "今日头条", "UC头条", "其他"].indexOf(accountType) != -1;
    }

    webLinkNeeded(accountType) {
        return ["网络媒体"].indexOf(accountType) != -1;
    }

    editorNameNeeded(accountType) {
        return ["网络媒体", "纸质媒体"].indexOf(accountType) != -1;
    }

    typeNameNeeded(accountType) {
        return ["其他"].indexOf(accountType) != -1;
    }

    confirmPayment() {
        this.pay('balance');
    }

    createOrder(shareForm) {

        let self=this;
        shareForm.$setSubmitted();

        if (!shareForm.$valid) {
            return;
        }

        this.localStorageService.set('reproduction', this.reproduction);

        if (self.userInfo.isGuest()) {
            //免登陆购买
            self.noLoginOrder()
        }else{
            this.placeOrder();
        }
    }

    placeOrder() {

        let post = {
            'original_id': this.original.id,
            'type': this.type,
            'reproduction': this.reproduction
        };

        let self = this;

        self.loading = true;

        this.OrderAPI.post(post).then(
            function (data) {

                self.loading = false;
                self.order = data.order;

                self.alipaySubmitUrl = data.alipay_url;
                self.buyStep = 'pay-type';
            },
            function (response) {
                self.loading = false;
                self.message.error(response.data);
            }
        )
    }

    pay(type) {

        let payment = {
            'pay_type': type
        };

        let self = this;

        self.loading = true;

        //微信浏览器内使用sdk支付
        if(type==='weixin' && typeof WeixinJSBridge !='undefined'){
            let payurl=''
            if(self.userInfo.isGuest()){
                payurl='/payment/weixin/'+self.order.order_id
            }else{
                payurl='/payment/weixin/'+self.order.id
            }
            location.href='https://api.yuanben.io/media/weixin/oauth/base?return='+payurl;
            return;
            // if(!self.WX_openid){
            //     //没有openid 跳转取值
            //     location.href='https://api.yuanben.io/media/weixin/oauth/base?return='+payurl;
            // }else{
            //     location.href=payurl;
            // }


        }

        if(self.userInfo.isGuest()){
            //未登录pc端用微信扫码购买
            self.noLoginPayWeixin()
            return
        }

        this.OrderAPI.one(self.order.id).post('pay', payment).then(
            (data) => {
                self.loading = false;
                self.order = data.order;

                if (type == 'balance') {
                    self.buySucceed();
                } else {
                    self.qrCodeSrc = data.qr_code_src;
                    self.buyStep = 'weixin-scan';

                    this.checkOrderStatus();
                }

            },
            (response) => {
                self.loading = false;
                self.message.error(response.data);
            }
        );
    }
    noLoginOrder(){
        let post = {
            'original_id': this.original.id,
            'type': this.type,
            'email':this.reproduction.account_email,
            'reproduction': this.reproduction
        };

        let self = this;

        self.loading = true;

        this.NoLoginPayAPI.post(post).then(
            function (data) {

                self.loading = false;
                self.order = data.order;

                self.alipaySubmitUrl = data.alipay_url;
                self.buyStep = 'pay-type';
            },
            function (response) {
                self.loading = false;
                self.message.error(response.data);
            }
        )
    }
    noLoginPayWeixin(){
        let self=this;
        let payment = {
            'pay_type': 'weixin',
            'order_id':self.order.order_id
        };
        this.NoLoginPayAPI.one('weixin').post('qrcode', payment).then(
            (data) => {
                self.loading = false;
                self.order = data.order;

                self.qrCodeSrc = data.qr_code_src;
                self.buyStep = 'weixin-scan';

                this.checkOrderStatus();

            },
            (response) => {
                self.loading = false;
                self.message.error(response.data);
            }
        );
    }

    externalPay() {
        this.checkOrderStatus();
        this.buyStep = 'wait';

        return true;
    }

    checkOrderStatus() {
        let self = this;
        if(self.userInfo.isGuest()){
            this.NoLoginPayAPI.one('order').one(self.order.order_id).get().then(
                (order) => {
                    if (order && order.status == 2) {
                        self.order = order;
                        self.buySucceed();

                    } else {
                        if ($('#cm-license').hasClass('active')) {
                            self.$timeout(() => {
                                self.checkOrderStatus();
                            }, 3000);
                        }
                    }
                },
                (response) => {
                    self.message.error(response.data);
                }
            );
        }else{
            this.OrderAPI.one(this.order.id).get().then(
                (order) => {
                    self.order = order;

                    if (order.status == 2) {

                        self.buySucceed();

                    } else {

                        if ($('#cm-license').hasClass('active')) {
                            self.$timeout(() => {
                                self.checkOrderStatus();
                            }, 3000);
                        }
                    }
                },
                (response) => {
                    self.message.error(response.data);
                }
            );
        }

    }

    buySucceed() {
        let self = this;
        self.modal.close('cm-license');
        self.message.success('购买成功');
        self.$scope.$emit("showTips",true)
        self.$timeout(() => {
            let notify = self.userInfo.isGuest();
            if (self.order.order_article) {
                self.$state.go('app.page.original.articleReproduction', {reproduction: self.order.order_article.yuanben_id, notify: notify});
            } else {
                self.$state.go('app.page.original.imageReproduction', {reproduction: self.order.order_image.yuanben_id, notify: notify});
            }

        }, 1000);

    }

    sendDemand() {
        this.willingPriceError = false;

        let price = $('#willing-price').val();

        if(price === '' || isNaN(parseFloat(price)) || !isFinite(price))
        {
            this.willingPriceError = true;
            return;
        }

        let self = this;

        this.articleDemand(price, () => {
            self.modal.close('none-license');
            self.message.success(self.tranlsteFilter('page-original-text124'));
        });
    }

    articleDemand(price, callback) {

        let post = {};

        if(typeof(price) !== 'undefined')
        {
            post['charge'] = price;
        }

        let self = this;

        self.ArticleAPI.one(self.original.id).customPOST(post, 'demand').then(
            () => {
                if(typeof(callback) !== 'undefined')
                {
                    callback();
                }
            }
        );
    }



    // $onInit(){
    //     let self=this;
    //     if (typeof WeixinJSBridge == "undefined"){
    //         if( document.addEventListener ){
    //             document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady, false);
    //         }else if (document.attachEvent){
    //             document.attachEvent('WeixinJSBridgeReady', self.onBridgeReady);
    //             document.attachEvent('onWeixinJSBridgeReady', self.onBridgeReady);
    //         }
    //     }else{
    //         self.onBridgeReady();
    //     }
    // }
    // onBridgeReady(){
    //     let self=this;
    //     this.WXpayAPI.one('openid').get({'timestr':Date.now()}).then(
    //         (res) => {
    //             if(!!res){
    //                 self.WX_openid=res;
    //             }
    //         },
    //         (response) => {
    //             self.message.error(response.data);
    //         }
    //     );
    // }
}

export default GetReproductionController;



// WEBPACK FOOTER //
// ./src/app/components/page/original/get-reproduction/get-reproduction.controller.js